import { MultipleSportsZone } from '@/interface/enum';

interface IMultipleSportsZoneConfig {
    pathPrefix: string;
}

const multipleSportsZoneConfigs: Record<MultipleSportsZone, IMultipleSportsZoneConfig> = {
    [MultipleSportsZone.None]: { pathPrefix: 'multiple-sports' },
    [MultipleSportsZone.Olympic]: { pathPrefix: 'olympics' },
    [MultipleSportsZone.AsianGames]: { pathPrefix: 'asian-games' },
};

const currentZone: MultipleSportsZone = MultipleSportsZone.AsianGames;

export function getCurrentMultipleSportsZone(): MultipleSportsZone {
    return currentZone;
}

export function getMultipleSportsZonePathPrefix(zone: MultipleSportsZone): string {
    return multipleSportsZoneConfigs[zone].pathPrefix;
}

export function isOlympicsZone() {
    return currentZone === MultipleSportsZone.Olympic;
}
